import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import Grid from '@material-ui/core/Grid';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Container, Box, Icon } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import Navigation from '../public/NavbarHomepage'
import ContactForm from '../public/ContactForm'
import { withTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) => ({
containerNavbar: {
    [theme.breakpoints.down("sm")]: {
        background: '#191919', 
        padding: '0 25px'
    },
    [theme.breakpoints.up("sm")]: {
        background: '#191919', 
        padding: '0 64px'
    },
  },
sidebarNavLegalitas: {
    border: "2px solid #d5d5d5",
    borderRadius: "5px",
    padding: "5px"
},
wrapperContentLegalitas: {
    border: "2px solid #d5d5d5",
    borderRadius: "5px",
    padding: "20px"
},
wrapperNavLegalitas: {
    padding: "5px",
    '&:hover': {
        background: "#e7e7e7"
    },
},
navLegalitas: {
    fontSize: '14px',
    color: 'black',
    '&:hover': {
        color: "#000"
    },
},
contentLegalitas: {
    border: "2px solid #d5d5d5",
    borderRadius: "5px",
    padding: "20px",
    maxHeight: '500px',
    overflowY: 'scroll',
    whiteSpace: "break-spaces",
}
}));

const PrivacyPolicy = ({ t }) => {
    const classes = useStyles();
    const [ input, setInput ] = useState({
      email: '',
      password: ''
    })
    const history = useHistory()
    const dispatch = useDispatch()


    const [lang, setLang] = useState('')

    const setLocale = (locale) => {
      setLang(locale)
    }

    const gotoTermsPage = (e) => {
      history.push('/termscondition') 
      };

    const gotoPolicyPage = (e) => {
      history.push('/privacypolicy') 
    };

    return (
      <>
        <Container maxWidth="xl" className={classes.containerNavbar} style={{}}>
          <Navigation locale={setLocale}/>
        </Container>
        <Container className="signUpPage py-5 mb-5" component="main" maxWidth="lg">
            <h1 className='font-size-28 bold'>{t('policy.legality')}</h1>
            <Grid container>
                <Grid item xs={12} md={2} >
                    <Box className={classes.sidebarNavLegalitas} sx={{ mr: "1rem"}}>
                        <div className={classes.wrapperNavLegalitas}>
                            <a className={classes.navLegalitas} onClick={gotoTermsPage}>
                                <AssignmentIcon /> {t('policy.sideBarTerms')}
                            </a>
                        </div>
                        <div className={classes.wrapperNavLegalitas} style={{background: "#e7e7e7"}}>
                            <a className={classes.navLegalitas} onClick={gotoPolicyPage}>
                                <AssignmentTurnedInIcon /> {t('policy.sideBarPolicy')}
                            </a>
                        </div>
                    </Box>
                </Grid>
                <Grid item xs={12} md={10}>
                    <Box className={classes.wrapperContentLegalitas} sx={{ mr: "1rem"}}>
                        <h1 className='font-size-22'>{t('policy.titlePolicy')}</h1>
                        <Box className={classes.contentLegalitas} sx={{ mr: "1rem"}}>
                            <p className='font-size-14 text-darkgrey'>
                                {t('policy.policyP1')}
                                <br/><br/>
                            <ol>
                                <li className='bold text-darkgrey mb-5'>
                                    {t('policy.policyP2Title')}
                                </li>
                                {t('policy.policyP2')}

                                <li className='bold text-darkgrey mb-5'>
                                    Cookies and Web Beacons
                                </li>
                                {t('policy.policyP3')}

                                <li className='bold text-darkgrey mb-5'>
                                    {t('policy.policyP4Title')}
                                </li>
                                {t('policy.policyP4')}

                                <li className='bold text-darkgrey mb-5'>
                                    {t('policy.policyP5Title')}
                                </li>
                                {t('policy.policyP5')}

                                <li className='bold text-darkgrey mb-5'>
                                    {t('policy.policyP6Title')}
                                </li>
                                {t('policy.policyP6')}
                            </ol>
                            </p>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Container>
        <div>
          <ContactForm/>
        </div>
      </>
    )
}

export default withTranslation()(PrivacyPolicy)
